/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = [".bg-dark[_ngcontent-%COMP%]{height:100vh}.btn-danger[_ngcontent-%COMP%]{background-color:red!important}.actions[_ngcontent-%COMP%]{width:300px;height:4rem;position:absolute;top:90%;left:40%;display:flex;justify-content:center;align-items:center;border-radius:5px}"];
export { styles as styles };
